import {UNIT_TYPE} from "../unit/support/UnitType";

export const mapResponseDtoToModel = (unit) => {
  return ({
    id: unit.externalId,
    floor_id: unit.floorExternalId,
    name: unit.name,
    unit_type: unit.type,
    unit_number: unit.number,
    display_name: `${UNIT_TYPE[unit.type].short} ${unit.number}`,
    custom_unit_id: unit.externalUniqueId,
    status: unit.status,
    technical_components: {
      port_gf_gv: unit.portGfGv,
      port_gf_ap: unit.portGfAp,
      ont: {
        serial_number: unit.macAddressOntSerialNumber,
        mac_address: unit.macAddressOnt
      },
      cpe: {mac_address: unit.macAddressCpe},
      home_id: {value: unit.homeIdentifier}
    },
    version: unit.version,
    documents: (unit?.documents || []).map((doc) => ({
      ...doc,
      tempId: doc.tempId || crypto.randomUUID()
    })),
  });
}